import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//icons
import { useTranslation } from 'react-i18next';
import { AiFillCloseCircle } from "react-icons/ai";
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const PaymentFailed = () => {
  const { t } = useTranslation(['cart']);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <div className="payment-failed-container">
      <div className="payment-failed-card">
        <AiFillCloseCircle className="cross-icon" />
        <h1 className='pedido-failed '>{t('failedPayment')}</h1>
        <p>{t('errorOccurred')}<br></br>{t('verifyPayment')}</p>
        <Row>
          <Col md={6} className='my-2'>
            <Link to={`/${assignedLibrary}/carrito`}>
              <Button className="retry-payment-button">{t('retryPayment')}</Button>
            </Link>
          </Col>
          <Col md={6} className='my-2'>
            <Link to="/">
              <Button className="contact-support-button">{t('goBackHome')}</Button>
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PaymentFailed;
